import { gql } from "@apollo/client";

export const GET_CRONOFY_ELEMENT_TOKEN = gql`
  query GetCronofyElementToken($subs: [String!]!, $user: String) {
    elementToken(subs: $subs, user: $user)
  }
`;
